import { PageSubtitleShort } from '@zoopla-eng/zds-components/headings';
import { styled } from '@zoopla-eng/zds-components/themes';

export const StyledTitle = styled(PageSubtitleShort, {
    fontGroup: 'teapot'
});
